/* Auroviq — storefront behaviour
   Cart (AJAX), buy now, wishlist, quantity steppers, carousel, header.
   No dependencies. Progressive: every control degrades to a working link. */
(function () {
  'use strict';

  var money = function (cents) {
    var c = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency: c || 'GBP'
      }).format(cents / 100);
    } catch (e) { return '£' + (cents / 100).toFixed(2); }
  };

  /* ---------------------------------------------------------------- toast */
  var toastEl;
  function toast(msg, kind) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'aq-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.dataset.kind = kind || 'ok';
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* --------------------------------------------------------------- drawer */
  function openDrawer(sel) {
    var p = document.querySelector(sel);
    if (!p) return;
    p.classList.add('is-open');
    document.documentElement.classList.add('aq-locked');
    var close = p.querySelector('[data-aq-close]');
    if (close) close.focus();
  }
  function closeDrawers() {
    document.querySelectorAll('.aq-drawer.is-open, .aq-panel.is-open')
      .forEach(function (p) { p.classList.remove('is-open'); });
    document.documentElement.classList.remove('aq-locked');
    document.querySelectorAll('[data-aq-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  /* ------------------------------------------------------------- minicart */
  function paintMiniCart(cart) {
    var list  = document.querySelector('[data-aq-mc-items]');
    if (!list) return;
    var empty = document.querySelector('[data-aq-mc-empty]');
    var foot  = document.querySelector('[data-aq-mc-foot]');
    var count = document.querySelector('[data-aq-mc-count]');
    var total = document.querySelector('[data-aq-mc-total]');

    if (count) count.textContent = cart.item_count;
    if (total) total.textContent = money(cart.total_price);

    var isEmpty = cart.item_count === 0;
    if (empty) empty.hidden = !isEmpty;
    if (foot) foot.hidden = isEmpty;

    list.innerHTML = '';
    cart.items.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'aq-mc__item';
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') +
          '" alt="" width="60" height="60" loading="lazy">'
        : '<div class="aq-mc__ph" aria-hidden="true"></div>';

      li.innerHTML =
        '<div class="aq-mc__media">' + img + '</div>' +
        '<div class="aq-mc__info">' +
          '<a class="aq-mc__title" href="' + item.url + '">' + item.product_title + '</a>' +
          '<p class="aq-mc__price">' + money(item.final_line_price) + '</p>' +
          '<div class="aq-mc__ctrl">' +
            '<div class="aq-qty aq-qty--sm">' +
              '<button type="button" data-aq-mc-set="' + item.key + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
              '<span class="aq-qty__val">' + item.quantity + '</span>' +
              '<button type="button" data-aq-mc-set="' + item.key + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="aq-mc__rm" data-aq-mc-set="' + item.key + '" data-to="0">Remove</button>' +
          '</div>' +
        '</div>';
      list.appendChild(li);
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintMiniCart(cart);
        paintCounts(cart);
        // The cart page renders its lines server-side, so repainting the
        // drawer is not enough — totals there would go stale. Reload it.
        if (document.querySelector('.aq-cart, .aq-cartlist')) {
          window.location.reload();
        }
        return cart;
      })
      .catch(function () { toast('Could not update basket', 'err'); });
  }

  function paintCounts(cart) {
    document.querySelectorAll('[data-aq-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('.cart-count-bubble span, [id*="cart-icon-bubble"] span')
      .forEach(function (el) {
        if (/^\d+$/.test(el.textContent.trim())) el.textContent = cart.item_count;
      });
  }

  /* ------------------------------------------------------------ cart count */
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintMiniCart(cart);
        document.querySelectorAll('[data-aq-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        // Keep Ambaz's own counter in sync while its header is still in use.
        document.querySelectorAll('.cart-count-bubble span, [id*="cart-icon-bubble"] span')
          .forEach(function (el) {
            if (/^\d+$/.test(el.textContent.trim())) el.textContent = cart.item_count;
          });
        return cart;
      })
      .catch(function () { /* non-fatal */ });
  }

  /* -------------------------------------------------------------- add/buy */
  function qtyFor(btn) {
    var scope = btn.closest('.aq-card, .aq-pdp, form') || document;
    var input = scope.querySelector('[data-aq-qty-input]');
    var n = input ? parseInt(input.value, 10) : 1;
    return (!n || n < 1) ? 1 : n;
  }

  function addToCart(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to basket');
        return data;
      });
    });
  }

  document.addEventListener('click', function (e) {
    /* --- open minicart from the header basket icon --- */
    var cartOpen = e.target.closest('[data-aq-cart-open]');
    if (cartOpen && document.querySelector('#aq-minicart')) {
      e.preventDefault();
      refreshCartCount().then(function () { openDrawer('#aq-minicart'); });
      return;
    }

    /* --- minicart line quantity / remove --- */
    var mcSet = e.target.closest('[data-aq-mc-set]');
    if (mcSet) {
      e.preventDefault();
      changeLine(mcSet.dataset.aqMcSet, parseInt(mcSet.dataset.to, 10));
      return;
    }

    /* --- quantity stepper --- */
    var step = e.target.closest('[data-aq-step]');
    if (step) {
      var wrap = step.closest('[data-aq-qty]');
      var inp = wrap && wrap.querySelector('[data-aq-qty-input]');
      if (inp) {
        var v = parseInt(inp.value, 10) || 1;
        v += parseInt(step.dataset.aqStep, 10);
        inp.value = v < 1 ? 1 : v;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    /* --- add to basket --- */
    var add = e.target.closest('[data-aq-add]');
    if (add && !add.disabled) {
      e.preventDefault();
      var label = add.innerHTML;
      add.disabled = true;
      add.classList.add('is-busy');
      addToCart(add.dataset.variant, qtyFor(add))
        .then(function () { return refreshCartCount(); })
        .then(function () {
          if (document.querySelector('#aq-minicart')) {
            openDrawer('#aq-minicart');
          } else {
            toast('Added to basket');
          }
        })
        .catch(function (err) { toast(err.message, 'err'); })
        .finally(function () {
          add.disabled = false;
          add.classList.remove('is-busy');
          add.innerHTML = label;
        });
      return;
    }

    /* --- buy now: add, then straight to checkout --- */
    var buy = e.target.closest('[data-aq-buy]');
    if (buy && !buy.disabled) {
      e.preventDefault();
      buy.disabled = true;
      buy.classList.add('is-busy');
      addToCart(buy.dataset.variant, qtyFor(buy))
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) {
          toast(err.message, 'err');
          buy.disabled = false;
          buy.classList.remove('is-busy');
        });
      return;
    }

    /* --- filters: show all values --- */
    var more = e.target.closest('[data-aq-show-more]');
    if (more) {
      e.preventDefault();
      var det = more.closest('details');
      det.querySelectorAll('[data-aq-more]').forEach(function (li) { li.hidden = false; });
      more.remove();
      return;
    }

    /* --- tab bar: jump to search --- */
    var tabSearch = e.target.closest('[data-aq-tab-search]');
    if (tabSearch) {
      e.preventDefault();
      var si = document.querySelector('[data-aq-search-input]');
      if (si) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function () { si.focus(); }, 250);
      } else {
        window.location.href = '/search';
      }
      return;
    }

    /* --- product gallery thumbnail --- */
    var thumb = e.target.closest('[data-aq-thumb]');
    if (thumb) {
      e.preventDefault();
      var main = document.getElementById('aq-gal-img');
      if (main) {
        main.src = thumb.dataset.full;
        main.removeAttribute('srcset');
        main.alt = thumb.dataset.alt || '';
      }
      document.querySelectorAll('[data-aq-thumb]').forEach(function (t) {
        t.classList.toggle('is-on', t === thumb);
      });
      return;
    }

    /* --- wishlist --- */
    var wish = e.target.closest('[data-aq-wish]');
    if (wish) {
      e.preventDefault();
      var handle = wish.dataset.handle;
      var on = Wishlist.toggle(handle);
      wish.setAttribute('aria-pressed', String(on));
      wish.classList.toggle('is-on', on);
      toast(on ? 'Saved to wishlist' : 'Removed from wishlist');
      Wishlist.paintCount();
    }
  });

  /* ------------------------------------------------------------- wishlist */
  var KEY = 'auroviq:wishlist';
  var Wishlist = {
    read: function () {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; }
      catch (e) { return []; }
    },
    write: function (list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
    },
    has: function (h) { return this.read().indexOf(h) !== -1; },
    toggle: function (h) {
      var l = this.read();
      var i = l.indexOf(h);
      if (i === -1) { l.push(h); } else { l.splice(i, 1); }
      this.write(l);
      return i === -1;
    },
    paintCount: function () {
      var n = this.read().length;
      document.querySelectorAll('[data-aq-wish-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
      });
    },
    paint: function () {
      var l = this.read();
      document.querySelectorAll('[data-aq-wish]').forEach(function (b) {
        var on = l.indexOf(b.dataset.handle) !== -1;
        b.setAttribute('aria-pressed', String(on));
        b.classList.toggle('is-on', on);
      });
      this.paintCount();
    }
  };

  /* --------------------------------------------------------------- header */
  function initHeader() {
    var header = document.querySelector('[data-aq-header]');
    if (!header) return;

    if (header.dataset.sticky === 'true') {
      var last = 0;
      window.addEventListener('scroll', function () {
        var y = window.pageYOffset;
        header.classList.toggle('is-stuck', y > 8);
        last = y;
      }, { passive: true });
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-aq-toggle]');
      if (t) {
        var sel = t.dataset.aqToggle;
        var panel = document.querySelector(sel);
        if (panel) {
          var open = panel.classList.toggle('is-open');
          t.setAttribute('aria-expanded', String(open));
          // Only full-screen drawers lock the page; dropdown panels must not.
          if (panel.classList.contains('aq-drawer')) {
            document.documentElement.classList.toggle('aq-locked', open);
          }
        }
        return;
      }
      if (e.target.closest('[data-aq-close]')) closeDrawers();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeDrawers();
    });
  }

  /* ------------------------------------------------------------- carousel */
  function initCarousels() {
    document.querySelectorAll('[data-aq-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-aq-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) {
        var nav = root.querySelector('.aq-car__nav');
        if (nav) nav.hidden = true;
        return;
      }

      var index = 0;
      var dots = root.querySelector('[data-aq-dots]');
      var timer = null;
      var interval = parseInt(root.dataset.interval, 10) || 0;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (dots) {
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'aq-car__dot';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', function () { go(i, true); });
          dots.appendChild(b);
        });
      }

      function paint() {
        if (dots) {
          Array.prototype.forEach.call(dots.children, function (d, i) {
            d.classList.toggle('is-on', i === index);
            d.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        }
        slides.forEach(function (s, i) {
          s.setAttribute('aria-hidden', String(i !== index));
        });
      }

      function go(i, user) {
        index = (i + slides.length) % slides.length;
        track.scrollTo({
          left: slides[index].offsetLeft - track.offsetLeft,
          behavior: reduced ? 'auto' : 'smooth'
        });
        paint();
        if (user) restart();
      }

      function next() { go(index + 1); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() {
        stop();
        if (interval > 0 && !reduced) timer = setInterval(next, interval);
      }

      var prevBtn = root.querySelector('[data-aq-prev]');
      var nextBtn = root.querySelector('[data-aq-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1, true); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1, true); });

      // Keep dots honest when the user swipes natively.
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var nearest = 0, best = Infinity;
          slides.forEach(function (s, i) {
            var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft);
            if (d < best) { best = d; nearest = i; }
          });
          if (nearest !== index) { index = nearest; paint(); }
        }, 90);
      }, { passive: true });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', restart);
      root.addEventListener('focusin', stop);

      paint();
      restart();
    });
  }

  /* ------------------------------------------------- nav overflow (priority+) */
  function initNavOverflow() {
    var nav = document.querySelector('.aq-header__nav .aq-nav');
    if (!nav) return;
    var more = nav.querySelector('[data-aq-nav-more]');
    var moreList = nav.querySelector('[data-aq-nav-more-list]');
    if (!more || !moreList) return;

    // Remember the original order once, so re-measuring is idempotent.
    var items = Array.prototype.filter.call(nav.children, function (li) {
      return li !== more;
    });

    function measure() {
      // Put everything back before measuring, or widths compound each pass.
      items.forEach(function (li) { nav.insertBefore(li, more); li.hidden = false; });
      moreList.innerHTML = '';
      more.hidden = true;

      var avail = nav.clientWidth;
      if (!avail) return;

      // Does it already fit with no More button?
      if (nav.scrollWidth <= avail + 1) return;

      more.hidden = false;
      var moreW = more.getBoundingClientRect().width;
      var used = moreW;
      var overflow = [];

      for (var i = 0; i < items.length; i++) {
        var w = items[i].getBoundingClientRect().width;
        if (used + w <= avail) {
          used += w;
        } else {
          overflow = items.slice(i);
          break;
        }
      }

      if (!overflow.length) { more.hidden = true; return; }

      overflow.forEach(function (li) {
        li.hidden = true;
        var a = li.querySelector('a');
        if (!a) return;
        var clone = document.createElement('li');
        var link = document.createElement('a');
        link.href = a.getAttribute('href');
        link.textContent = a.textContent.trim();
        if (a.hasAttribute('aria-current')) link.setAttribute('aria-current', 'page');
        clone.appendChild(link);
        moreList.appendChild(clone);
      });
    }

    var t;
    function schedule() { clearTimeout(t); t = setTimeout(measure, 120); }

    measure();
    window.addEventListener('resize', schedule, { passive: true });

    // The strip can change width without a window resize — a late stylesheet,
    // a scrollbar appearing, a container query. Watch the element itself.
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(schedule);
      ro.observe(nav);
      if (nav.parentElement) ro.observe(nav.parentElement);
    }
    // Web fonts land after first paint and change every label's width.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure).catch(function () {});
    }

    var btn = more.querySelector('.aq-nav__morebtn');
    if (btn) {
      btn.addEventListener('click', function () {
        var open = more.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
      document.addEventListener('click', function (e) {
        if (!more.contains(e.target)) {
          more.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  /* ---------------------------------------------------- search suggestions */
  function initSuggest() {
    var wrap = document.querySelector('[data-aq-search]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-aq-search-input]');
    var panel = wrap.querySelector('#aq-suggest');
    var body = wrap.querySelector('[data-aq-suggest-body]');
    var clear = wrap.querySelector('[data-aq-search-clear]');
    var header = document.querySelector('[data-aq-header]');
    if (!input || !panel || !body) return;
    if (header && header.dataset.suggest === 'false') return;

    var limit = parseInt(header && header.dataset.suggestLimit, 10) || 6;
    var timer = null;
    var lastQuery = '';
    var active = -1;
    var controller = null;

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    }
    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function options() { return panel.querySelectorAll('[role="option"]'); }

    function highlight(i) {
      var opts = options();
      if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      opts.forEach(function (o, n) {
        o.classList.toggle('is-active', n === active);
        o.setAttribute('aria-selected', String(n === active));
      });
      opts[active].scrollIntoView({ block: 'nearest' });
    }

    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function render(data, q) {
      var res = (data && data.resources && data.resources.results) || {};
      var products = res.products || [];
      var collections = res.collections || [];
      var html = '';

      if (collections.length) {
        html += '<p class="aq-suggest__h">Categories</p><ul class="aq-suggest__list">';
        collections.forEach(function (c) {
          var label = String(c.title || '').split('|')[0].trim();
          html += '<li role="option" aria-selected="false" class="aq-suggest__row aq-suggest__row--cat">' +
                    '<a href="' + esc(c.url) + '">' + esc(label) + '</a></li>';
        });
        html += '</ul>';
      }

      if (products.length) {
        html += '<p class="aq-suggest__h">Products</p><ul class="aq-suggest__list">';
        products.forEach(function (p) {
          // suggest.json hands back the full-size original (1000-1500px) for a
          // 44px thumbnail. Ask the CDN for a thumbnail instead.
          var src = p.featured_image && p.featured_image.url;
          var img = src
            ? '<img src="' + esc(src.replace(/(\.[a-z]+)(\?|$)/i, '_88x$1$2')) +
              '" alt="" width="44" height="44" loading="lazy" decoding="async">'
            : '<span class="aq-suggest__ph"></span>';
          // suggest.json returns price as a STRING in major units ("23.88"),
          // unlike cart.js which uses cents. money() expects cents, so
          // passing this straight through would render £0.24.
          var raw = (p.price_min != null) ? p.price_min : p.price;
          var cents = (raw == null || raw === '') ? null : Math.round(parseFloat(raw) * 100);
          var price = (cents == null || isNaN(cents)) ? '' : money(cents);
          html += '<li role="option" aria-selected="false" class="aq-suggest__row">' +
                    '<a href="' + esc(p.url) + '">' +
                      '<span class="aq-suggest__img">' + img + '</span>' +
                      '<span class="aq-suggest__t">' + esc(p.title) + '</span>' +
                      '<span class="aq-suggest__p">' + price + '</span>' +
                    '</a></li>';
        });
        html += '</ul>';
      }

      if (!products.length && !collections.length) {
        html = '<p class="aq-suggest__none">No matches for &ldquo;' + esc(q) + '&rdquo;</p>';
      } else {
        html += '<a class="aq-suggest__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">' +
                  'See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
      }

      body.innerHTML = html;
      open();
    }

    function fetchSuggestions(q) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=product,collection' +
                '&resources[limit]=' + limit +
                '&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { render(d, q); })
        .catch(function (err) { if (err.name !== 'AbortError') close(); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clear) clear.hidden = q.length === 0;
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      if (q === lastQuery && !panel.hidden) return;
      lastQuery = q;
      timer = setTimeout(function () { fetchSuggestions(q); }, 180);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && body.innerHTML) open();
    });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Enter') {
        var opts = options();
        if (active > -1 && opts[active]) {
          e.preventDefault();
          opts[active].querySelector('a').click();
        }
      } else if (e.key === 'Escape') { close(); input.blur(); }
    });

    if (clear) {
      clear.addEventListener('click', function () {
        input.value = '';
        clear.hidden = true;
        lastQuery = '';
        close();
        input.focus();
      });
    }

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
  }

  /* ------------------------------------------------------- variant picker */
  function initVariants() {
    var data = document.querySelector('[data-aq-variants]');
    var selects = document.querySelectorAll('[data-aq-option]');
    if (!data || !selects.length) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    function apply() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });

      var add = document.querySelector('.aq-pdp [data-aq-add]');
      var buy = document.querySelector('.aq-pdp [data-aq-buy]');
      var price = document.querySelector('.aq-pdp .aq-price__now');

      if (!match) {
        [add, buy].forEach(function (b) { if (b) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); } });
        if (add) add.textContent = 'Unavailable';
        return;
      }

      // Untracked stock always sells, matching the Liquid rule.
      var sellable = match.available || !match.inventory_management;
      [add, buy].forEach(function (b) {
        if (!b) return;
        b.dataset.variant = match.id;
        b.disabled = !sellable;
        b.setAttribute('aria-disabled', String(!sellable));
      });
      if (add) add.textContent = sellable ? 'Add to basket' : 'Sold out';
      if (price) price.textContent = money(match.price);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }

    selects.forEach(function (s) { s.addEventListener('change', apply); });
  }

  /* --------------------------------------------------------- wishlist page */
  function initWishlistPage() {
    var grid = document.querySelector('[data-aq-wl-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-aq-wl-empty]');
    var loading = document.querySelector('[data-aq-wl-loading]');
    var countEl = document.querySelector('[data-aq-wl-count]');
    var clearBtn = document.querySelector('[data-aq-wl-clear]');

    function done(n) {
      if (loading) loading.hidden = true;
      if (countEl) countEl.textContent = n;
      grid.hidden = n === 0;
      if (empty) empty.hidden = n !== 0;
      if (clearBtn) clearBtn.hidden = n === 0;
    }

    var handles = Wishlist.read();
    if (!handles.length) { done(0); return; }

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var live = items.filter(Boolean);

      // Drop handles that no longer resolve so the list cannot rot.
      if (live.length !== handles.length) {
        Wishlist.write(live.map(function (p) { return p.handle; }));
        Wishlist.paintCount();
      }

      grid.innerHTML = live.map(function (p) {
        var v = p.variants && p.variants[0];
        var sellable = v && (v.available || !v.inventory_management);
        var img = p.featured_image
          ? '<img src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') +
            '" alt="" width="300" height="300" loading="lazy">'
          : '<div class="aq-media__ph" aria-hidden="true">' + (p.vendor || '') + '</div>';
        return '<article class="aq-card">' +
          '<button type="button" class="aq-wish is-on" data-aq-wish data-handle="' + p.handle +
            '" aria-pressed="true" aria-label="Remove ' + p.title.replace(/"/g, '') + ' from wishlist">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1L12 21l7.7-7.6 1.1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>' +
          '</button>' +
          '<div class="aq-media">' + img + '</div>' +
          '<div class="aq-card__body">' +
            '<h3 class="aq-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
            '<p class="aq-card__pack"></p>' +
            '<div class="aq-card__foot">' +
              '<div class="aq-price"><span class="aq-price__now">' + money(p.price) + '</span></div>' +
              '<p class="aq-unit"></p>' +
              '<div class="aq-card__cta"><div class="aq-card__row">' +
                '<button type="button" class="aq-btn aq-btn--primary aq-card__add" data-aq-add data-variant="' +
                  (v ? v.id : '') + '"' + (sellable ? '' : ' disabled aria-disabled="true"') + '>' +
                  (sellable ? 'Add to basket' : 'Sold out') + '</button>' +
              '</div></div>' +
            '</div>' +
          '</div>' +
        '</article>';
      }).join('');

      done(live.length);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        Wishlist.write([]);
        Wishlist.paintCount();
        grid.innerHTML = '';
        done(0);
      });
    }

    // Removing a heart on this page should also remove the tile.
    grid.addEventListener('click', function (e) {
      var w = e.target.closest('[data-aq-wish]');
      if (!w) return;
      var card = w.closest('.aq-card');
      setTimeout(function () {
        if (!Wishlist.has(w.dataset.handle) && card) {
          card.remove();
          done(grid.querySelectorAll('.aq-card').length);
        }
      }, 60);
    });
  }

  /* ----------------------------------------------------------------- boot */
  function boot() {
    initVariants();
    initNavOverflow();
    initWishlistPage();
    initSuggest();
    Wishlist.paint();
    initHeader();
    initCarousels();
    refreshCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  window.Auroviq = { toast: toast, refreshCartCount: refreshCartCount, wishlist: Wishlist };
})();
